import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PACIMPgpWithProvider } from '@core/model';
import { TableColumn } from '@mynexus/mynexus-ui-lib';

interface ServicingFacilityContactInfo {
  city: string;
  state: string;
  street: string;
  zipCode: string
}

@Component({
    selector: 'servicing-facility-contact-info',
    templateUrl: './servicing-facility-contact-info.component.html',
    styleUrls: ['./servicing-facility-contact-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicingFacilityContactInfoComponent implements OnInit {
  @Input() providerAccount: PACIMPgpWithProvider;

  contactInfo!: [ServicingFacilityContactInfo];
  contactInfoColumns = [
    new TableColumn('Street', 'street'),
    new TableColumn('City', 'city'),
    new TableColumn('State', 'state'),
    new TableColumn('ZIP Code', 'zipCode')
  ];

  ngOnInit(): void {
    this.contactInfo = [{
      city: this.providerAccount.physicalCity,
      state: this.providerAccount.physicalState,
      street: this.providerAccount.physicalStreet,
      zipCode: this.providerAccount.physicalZip
    }];
  }

}
